import React from 'react';
import { Space, Typography } from 'antd';

const { Text } = Typography;

interface ScrapeStatsCardProps {
    stats: { total: number; scraped: number; pending: number; failed: number } | null;
}

export const ScrapeStatsCard: React.FC<ScrapeStatsCardProps> = ({ stats }) => {
    if (!stats) return null;

    return (
        <div style={{ marginBottom: 16, padding: '12px 16px', background: '#f5f5f5', borderRadius: 8 }}>
            <Space size="large">
                <Text>总计: <strong>{stats.total}</strong></Text>
                <Text type="success">已抓取: <strong>{stats.scraped}</strong></Text>
                <Text type="warning">待抓取: <strong>{stats.pending}</strong></Text>
                <Text type="danger">失败: <strong>{stats.failed}</strong></Text>
                {stats.pending > 0 && (
                    <Text type="secondary" style={{ fontSize: 12 }}>
                        (每 5 秒自动刷新)
                    </Text>
                )}
            </Space>
        </div>
    );
};
